import React from 'react';
import { Box } from '@chakra-ui/react';

const BlueText = (text) => (
  <Box as="span" color="font.highlight">
    {text}
  </Box>
);

export default BlueText;
